import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { mediaApi } from "../../api/endpoints";

export function useMediaList(params?: {
  page?: number;
  limit?: number;
  search?: string;
  mimeType?: string;
  folder?: string;
}) {
  return useQuery({
    queryKey: ["media", params],
    queryFn: () => mediaApi.list(params).then((r) => r.data),
  });
}

export function useUploadMedia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, alt, folder }: { file: File; alt?: string; folder?: string }) =>
      mediaApi.upload(file, alt, folder).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["media"] }),
  });
}

export function useDeleteMedia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => mediaApi.delete(id).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["media"] }),
  });
}

export function useUpdateMedia() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...data }: { id: string; alt?: string }) =>
      mediaApi.update(id, data).then((r) => r.data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["media"] }),
  });
}
